import { z } from 'zod';
import { DevPreferenceFieldSchema } from '../enums.js';
import { IdSchema } from './common.js';
/** One question in the TDD questionnaire, tailored per project by the LLM. */
export const QuestionnaireQuestionSchema = z.object({
    id: IdSchema, // stable within one questionnaire, e.g. "q-auth"
    prompt: z.string().min(1).max(500),
    helpText: z.string().max(1000).optional(),
    suggestedOptions: z
        .array(z.object({ label: z.string().min(1).max(300), description: z.string().max(500).optional() }))
        .max(6)
        .default([]),
    prefilledFrom: z.enum(['org_default', 'user_default']).optional(),
    /** Which DevPreferences field (schemas/org.ts) this question answers, if any — lets the UI
     * offer "save as org default" on the exact question, rather than guessing from its prompt
     * text. Omitted for questions with no fixed-field equivalent (e.g. "third-party services"). */
    devPreferenceField: DevPreferenceFieldSchema.optional(),
});
export const QuestionnaireAnswerSchema = z.object({
    questionId: IdSchema,
    selectedOptionLabel: z.string().max(300).optional(),
    freeText: z.string().max(1000).optional(),
});
/** projects/{id}/questionnaires/{id} */
export const QuestionnaireSchema = z.object({
    id: IdSchema,
    questions: z.array(QuestionnaireQuestionSchema),
    answers: z.array(QuestionnaireAnswerSchema).default([]),
    completedAt: z.string().datetime({ offset: true }).nullable().default(null),
    createdAt: z.string().datetime({ offset: true }),
});
export const SubmitQuestionnaireAnswersInputSchema = z.object({
    answers: z.array(QuestionnaireAnswerSchema).min(1),
});
/** One section of the TDD. `id` is stable so tasks can trace back to it (e.g. "sec-auth"). */
export const TddSectionSchema = z.object({
    id: IdSchema,
    title: z.string().min(1).max(200),
    body: z.string().min(1).max(20000),
});
export const TDD_SECTION_KEYS = [
    'overview',
    'architecture',
    'data_model',
    'api_surface',
    'security',
    'deployment',
    'testing',
    'risks',
    'open_questions',
];
/** The structured content of one TDD version. */
export const TddContentSchema = z.object({
    sections: z.array(TddSectionSchema).min(1),
});
export const SaveTddDraftInputSchema = z.object({
    sections: z.array(TddSectionSchema).min(1),
    changeSummary: z.string().max(500).optional(),
});
//# sourceMappingURL=tdd.js.map